import React, { useState, useContext } from "react";
import styled, { css } from "styled-components";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import { AccordionContext } from "./AccordionContainer";
import CircleNumber from "./CircleNumber";
import { statusStyles } from "../styles";
import down_chevron from "../assets/chevron.png";
/* eslint-disable */
const styleSheet = {
  cardHeaderTitle: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "15px",
    marginBottom: "0px",
  },
  subContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  iconContainer: {
    //to delete ?
    marginBottom: "0px",
    marginRight: "15px",
    backgroundColor: "red",
  },
  statusToastContainer: {
    Success: {
      backgroundColor: statusStyles.Success.backgroundColor,
    },
    Pending: {
      backgroundColor: statusStyles.Pending.backgroundColor,
    },
    Fail: {
      backgroundColor: statusStyles.Fail.backgroundColor,
    },
    PendingUnallowed: {
      backgroundColor: statusStyles.PendingUnallowed.backgroundColor,
    },
    Skipped: {
      backgroundColor: "#F2EBF4",
    },
  },
  statusToastParagraph: {
    marginBottom: 0,
    Success: {
      color: statusStyles.Success.color,
    },
    Pending: {
      color: statusStyles.Pending.color,
    },
    Fail: {
      color: statusStyles.Fail.color,
    },
    PendingUnallowed: {
      color: statusStyles.PendingUnallowed.color,
    },
    Skipped: {
      color: "#B19CD7",
    },
  },
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 0px solid black;
  cursor: ${(props) => (props.isToggable ? "pointer" : "not-allowed")};
`;

const StatusToastContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 30px;
  margin-right: 15px;
  padding: 8px;
  margin-bottom: none;
  background-color: #e6fbf1;
  border-radius: 4px;
  margin-left: -130px;
  margin-right: 25px;
`;

const StatusToastParagraph = styled.p`
  margin-bottom: 0px;
  color: #20c374;
`;

const RotatingDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  border-radius: 50%;

  ${({ rotate }) =>
    rotate &&
    css`
      transform: rotate(180deg);
    `}
`;

const Chevron = styled.img`
  height: auto;
  max-width: 100%;
`;

export default function ToggleHeader({ children, eventKey, isToggable }) {
  const { accordionData } = useContext(AccordionContext);
  const [rotate, setRotate] = useState(false);
  const id = eventKey;
  const accordionElementStatus = accordionData[id - 1].status;
  const adjustedStatusForPending = isToggable
    ? accordionElementStatus
    : "PendingUnallowed";
  const handleDivClick = () => {
    setRotate(!rotate);
  };
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    handleDivClick();
  });

  return (
    <Container
      onClick={isToggable ? decoratedOnClick : null}
      isToggable={isToggable}
    >
      <div id="sub-container" style={styleSheet.subContainer}>
        <StatusToastContainer
          id="icon-container"
          style={styleSheet.statusToastContainer[adjustedStatusForPending]}
        >
          <StatusToastParagraph
            style={styleSheet.statusToastParagraph[adjustedStatusForPending]}
          >
            {accordionElementStatus}
          </StatusToastParagraph>
        </StatusToastContainer>
        <CircleNumber number={id} status={adjustedStatusForPending} />
        <p style={styleSheet.cardHeaderTitle}>{children}</p>
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <RotatingDiv rotate={rotate} onClick={decoratedOnClick}>
          <Chevron src={down_chevron} alt="my icon" />
        </RotatingDiv>
      </div>
    </Container>
  );
}
/* eslint-enable */
